import { PanelDireccion } from "./PanelDireccion";
import { PanelInicio } from "./PanelInicio";

/**
 * Inicio: el panel nuevo (45, 30/10/2026) y, mientras la base no tenga sus funciones, el de
 * siempre. Así la app se puede publicar antes o después de la migración sin romper nada.
 */
export const Inicio = () => <PanelInicio alFallar={<PanelDireccion />} />;
